import { JWT_STORAGE_KEY, LOGIN_URL, IMPERSONATION_STORAGE_KEY } from './constants';

// Extract token from URL fragment if present (from login redirect)
export function extractTokenFromUrl(): boolean {
  const hash = window.location.hash;
  if (hash && hash.includes('token=')) {
    const params = new URLSearchParams(hash.substring(1));
    const token = params.get('token');
    if (token) {
      setToken(decodeURIComponent(token));
      // Clean up URL by removing the hash
      window.history.replaceState(null, '', window.location.pathname);
      return true;
    }
  }
  return false;
}

export function getToken(): string | null {
  return localStorage.getItem(JWT_STORAGE_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(JWT_STORAGE_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(JWT_STORAGE_KEY);
}

export function clearImpersonation(): void {
  sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY);
}

export function isAuthenticated(): boolean {
  const token = getToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000;
    return Date.now() < exp;
  } catch {
    return false;
  }
}

export function redirectToLogin(): void {
  clearToken();
  window.location.href = LOGIN_URL;
}
